/** Encuesta más reciente de un equipo (por fecha_fin, luego fecha_inicio). */
export function getLatestSurvey(encuestas) {
    if (!encuestas?.length) return null;
    return [...encuestas]
        .filter(Boolean)
        .sort((a, b) => {
            const finA = new Date(a.fecha_fin || 0).getTime();
            const finB = new Date(b.fecha_fin || 0).getTime();
            if (finB !== finA) return finB - finA;
            const iniA = new Date(a.fecha_inicio || 0).getTime();
            const iniB = new Date(b.fecha_inicio || 0).getTime();
            return iniB - iniA;
        })[0];
}

/** Resuelve un par equipo↔encuesta por equipo (manual o última por defecto). */
export function resolveTeamSurveyPairs(companies, companyId, teamIds, manualSurveyIds) {
    const company = companies.find((c) => c.id_empresa === companyId);
    if (!company?.equipos?.length) return [];

    return teamIds
        .map((teamId) => {
            const team = company.equipos.find((t) => t.id_equipo === teamId);
            if (!team?.encuestas?.length) return null;
            const teamSurveyIds = new Set(team.encuestas.map((e) => e.id_encuesta));
            const manualId = manualSurveyIds.find((id) => teamSurveyIds.has(id));
            const survey = manualId
                ? team.encuestas.find((e) => e.id_encuesta === manualId)
                : getLatestSurvey(team.encuestas);
            if (!survey) return null;
            return { id_equipo: teamId, id_encuesta: survey.id_encuesta };
        })
        .filter(Boolean);
}

/** IDs de encuesta a marcar al seleccionar equipos (última por equipo). */
export function surveysForTeams(companies, companyId, teamIds) {
    const company = companies.find((c) => c.id_empresa === companyId);
    if (!company) return [];
    return teamIds
        .map((teamId) => {
            const team = company.equipos.find((t) => t.id_equipo === teamId);
            const latest = getLatestSurvey(team?.encuestas);
            return latest?.id_encuesta ?? null;
        })
        .filter((id) => id != null);
}
